type Props = {
  title: string;
  subTitle?: string;
};
const Header = ({ title, subTitle }: Props) => (
  <div className="py-4 sm:py-8">
    <h1 id="title" className="text-2xl">
      {title}
    </h1>
    {subTitle && (
      <p id="subtitle" className="text-base">
        {subTitle}
      </p>
    )}
  </div>
);

export default Header;
